module.exports = __webpack_public_path__ + "static/media/invoice_image.b6ca46bc.jpg";